/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CorrectionDashboardViewModel } from "../types/CorrectionDashboardViewModel.ts";

export const correctionDashboardViewModelSchema = z.object({
  pageNumber: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
  seeOnlyOwnExamItem: z.optional(z.boolean()),
  filterStartDate: z.string().datetime().nullish(),
  filterEndDate: z.string().datetime().nullish(),
  filterDisciplineId: z.number().int().nullish(),
  onlyShowEnglishCourse: z.optional(z.boolean()),
}) as unknown as ToZod<CorrectionDashboardViewModel>;
